import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")

  return (_openBlock(), _createBlock(_component_base_image, _mergeProps({..._ctx.$attrs, ..._ctx.$props}, {
    src: $options.themedPath,
    loading: "lazy"
  }), null, 16 /* FULL_PROPS */, ["src"]))
}